<template>
  <v-card class="mt-6">
    <v-card-title>Regras do Hotel</v-card-title>
    <v-card-text>
      <!-- Aviso de Fumantes -->
      <div class="mb-4">
        <v-switch
          :value="config.smoking_rule_enabled"
          color="primary"
          inset
          label="Ativar aviso de fumantes"
          @change="updateField('smoking_rule_enabled', $event)"
        />
        <v-textarea
          v-if="config.smoking_rule_enabled"
          :value="config.smoking_rule_text"
          outlined
          label="Texto do aviso de fumantes"
          rows="2"
          auto-grow
          hint="Exemplo: É proibido fumar nas dependências do hotel. Multa de R$ 500,00 em caso de infração."
          persistent-hint
          @input="updateField('smoking_rule_text', $event)"
        />
      </div>

      <v-divider class="mb-4" />

      <!-- Outras Regras -->
      <div>
        <v-switch
          :value="config.extra_rule_enabled"
          color="primary"
          inset
          label="Ativar outras regras"
          @change="updateField('extra_rule_enabled', $event)"
        />
        <v-textarea
          v-if="config.extra_rule_enabled"
          :value="config.extra_rule_text"
          outlined
          label="Texto das outras regras"
          rows="3"
          auto-grow
          hint="Descreva outras regras que devem ser informadas ao hóspede no voucher e no pré check-in."
          persistent-hint
          @input="updateField('extra_rule_text', $event)"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RulesSettings',
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
